import { render, staticRenderFns } from "./SetupGanalytics.vue?vue&type=template&id=72f3202c&scoped=true&"
import script from "./SetupGanalytics.vue?vue&type=script&lang=js&"
export * from "./SetupGanalytics.vue?vue&type=script&lang=js&"
import style0 from "./SetupGanalytics.vue?vue&type=style&index=0&id=72f3202c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f3202c",
  null
  
)

export default component.exports